import { BuilderComponentConfig } from '../interfaces/page-creator';
import { BuilderBlock } from '@builder.io/angular';

/***
 * Decorator to automatically export components to the builder.io system.
 * The decorator has some limitations:
 * - If the decorator is in a standalone component, the component has to be imported into at least one module or other standalone component.
 ***/
export function CustomBuilderComponent(config: BuilderComponentConfig): any {
  // FIXME: decorator not working with new standalone system
  return function (target: Object): void {
    try {
      BuilderBlock(config)(target as any);
    } catch (e) {
      console.error('Error registring component in builder.io', e);
    }
  };
}
